<template>
  <div class="va-row">
    <div class="flex md12 xs12">
      <vuestic-data-table
        class="text-center"
        :apiMode="true"
        :apiUrl="apiUrl"
        :httpOptions="httpOptions"
        :defaultPerPage="defaultTablePerPage"
        :tableFields="tableFields"
        :actions="false"
        :actionsType="'conference'"
        :additionalActions="true"
      >
        <template slot="additionalTableControl">
          <!-- <button
            class="btn rounded btn-micro btn-with-icon-micro btn-primary"
            :class="{ sidebarOpen }"
          >
            <div class="btn-with-icon-content">
              <i class="fa fa-download"></i>
              Download
            </div>
          </button> -->
          <router-link
            class="btn btn-micro btn-primary rounded mx-3"
            :class="{ sidebarOpen }"
            :to="{ name: 'callflow' }"
          >
            {{ $t('menu.conferenceBridge.callflow') }}
          </router-link>
          <!-- <router-link
            class="btn btn-micro btn-primary rounded"
            :class="{ sidebarOpen }"
            :to="{ name: 'callflow' }"
          >
            <i class="ion-md-add ion"></i>
            {{ $t('buttons.create') }}
          </router-link> -->
        </template>
      </vuestic-data-table>
    </div>
    <app-filterbar
      v-on:apply-filters="applyFilters"
      v-on:reset-filters="resetFilters"
    >
      <template slot="filterbar-content"> </template>
    </app-filterbar>
  </div>
</template>

<script>
import Vue from 'vue'
import AppFilterbar from '@/components/admin/app-filterbar/AppFilterbar'
import { mapGetters, mapActions } from 'vuex'
import FirstRecipientColumn from './components/first-recipient-column'
Vue.component('first-recipient-column', FirstRecipientColumn)
import SecondRecipientColumn from './components/second-recipient-column'
Vue.component('second-recipient-column', SecondRecipientColumn)
import FirstStatusColumn from './components/first-status-column'
Vue.component('first-status-column', FirstStatusColumn)
import SecondStatusColumn from './components/second-status-column'
Vue.component('second-status-column', SecondStatusColumn)
export default {
  components: {
    AppFilterbar
  },
  data() {
    return {
      httpOptions: {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('cTok') }
      },
      tableFields: [
        {
          name: 'scheduledDateTime',
          title: 'Scheduled<br> date & time'
        },
        {
          name: 'actualDateTime',
          title: 'Actual<br> date & time'
        },
        {
          name: 'callDuration',
          title: 'Call Duration'
        },
        {
          name: 'callerId',
          title: 'Caller ID'
        },
        {
          name: '__component:first-recipient-column',
          title: '1st Recipient'
        },
        {
          name: '__component:first-status-column',
          title: '1st Recipient<br> Status',
          dataClass: 'with-icon'
        },
        {
          name: '__component:second-recipient-column',
          title: '2nd Recipient'
        },
        {
          name: '__component:second-status-column',
          title: '2nd Recipient<br> Status',
          dataClass: 'with-icon'
        },
        {
          name: 'callStatus',
          title: 'Call Status'
        }
      ],
      defaultTablePerPage: 10
    }
  },
  computed: {
    ...mapGetters(['sidebarOpen']),
    apiUrl() {
      return `${process.env.VUE_APP_WEBSITE_URL}engine/bridge/api/v1/call/all`
    }
  },
  methods: {
    openPopup() {
      this.$store.dispatch('togglePopup', true)
    },
    async openFilterbar() {
      this.$store.dispatch('toggleFilterbar', true)
    },
    applyFilters() {},
    resetFilters() {}
  }
}
</script>
<style lang="scss">
// @media (max-width: 1489px) {
//   .sidebarOpen {
//     margin-top: 15px;
//   }
// }
// @media (max-width: 1229px) {
//   .additionalTableControl .btn {
//     margin-top: 15px;
//   }
// }
</style>
